import { text } from '../lib/format.js';

/**
 * くじ(F랜덤박스) 경품 등급 뱃지. 원본 lottery/product/prize_list.php:496-518 의
 * switch 문 배색을 그대로 옮겼다 - randombox/product/prize_list.php 의
 * getGradeGradient(components/GradeBadge.tsx)와는 등급 체계(A~E,L 대 1~7,L)도
 * 배색도 다른 별개 화면이라 색상표를 나눠 둔다. 한쪽만 고치면 둘이 어긋난다.
 *
 * 원본은 default 분기도 L 과 같은 색을 썼다 - 여기서도 그대로 둔다.
 * 텍스트 색도 원본과 같이 등급과 무관하게 항상 검정이다(.badge-grade 기본값).
 */
const LOTTERY_GRADE_GRADIENT: Record<string, string> = {
  A: 'linear-gradient(to right, rgb(255, 223, 0), rgb(255, 239, 128))',
  B: 'linear-gradient(to right, rgb(192, 192, 192), rgb(224, 224, 224))',
  C: 'linear-gradient(to right, rgb(255, 153, 102), rgb(255, 204, 153))',
  D: 'linear-gradient(to right, rgb(255, 102, 102), rgb(255, 153, 153))',
  E: 'linear-gradient(to right, rgb(204, 102, 255), rgb(229, 178, 255))',
  L: 'linear-gradient(to right, rgb(255, 102, 102), rgb(255, 178, 178))',
};
const LOTTERY_GRADE_GRADIENT_DEFAULT = LOTTERY_GRADE_GRADIENT.L;

/** 원본 상세 화면은 등급 칸(td) 자체를 이 그라데이션으로 칠한다 - lottery PrizesPage. */
export function lotteryGradeGradient(grade: string | null): string {
  return LOTTERY_GRADE_GRADIENT[(grade ?? '').toUpperCase()] ?? LOTTERY_GRADE_GRADIENT_DEFAULT!;
}

export function LotteryGradeBadge({ grade }: { grade: string | null }) {
  return (
    <span className="badge-grade" style={{ background: lotteryGradeGradient(grade) }}>
      {text(grade)}
    </span>
  );
}
